import {Injectable} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class SEOService {

    constructor(
        private title: Title,
        private metas: Meta
    ) {
    }

    updateDATA(TITLE: string, KEYWORDS: any, DESCRIPTION: string, URL: string, IMG: string): void {
        this.title.setTitle(TITLE);
        /* PRINCIPALES */
        this.metas.updateTag({
            name: 'keywords',
            content: KEYWORDS
        });
        this.metas.updateTag({
            name: 'description',
            content: DESCRIPTION
        });
        /* FACEBOOK Y LINKEDIN */
        this.metas.updateTag({
            property: 'og:url',
            content: URL
        });
        this.metas.updateTag({
            property: 'og:title',
            content: TITLE
        });
        this.metas.updateTag({
            property: 'og:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            property: 'og:image',
            content: IMG
        });
        /* TWITTER */
        this.metas.updateTag({
            name: 'twitter:title',
            content: TITLE
        });
        this.metas.updateTag({
            name: 'twitter:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            name: 'twitter:image',
            content: IMG
        });
    }

}
